document.addEventListener('DOMContentLoaded', function () {
  const heroSections = document.querySelectorAll(".interimHero");

  heroSections.forEach(function (hero) {
    const videoColumns = hero.querySelectorAll(".interimHero__videoColumn");

    if (videoColumns.length === 0) return;

    let currentlyPlayingVideo = null;

    // Check if mobile (< 992px to match Bootstrap's lg breakpoint)
    function isMobile() {
      return window.innerWidth < 992;
    }

    // Autoplay first video on mobile
    function handleMobileAutoplay() {
      if (isMobile() && videoColumns.length > 0) {
        const firstVideo = videoColumns[0].querySelector('video');
        if (firstVideo) {
          firstVideo.play();
        }
      }
    }

    // Initial check for mobile autoplay
    handleMobileAutoplay();

    // Handle resize events
    window.addEventListener('resize', function () {
      handleMobileAutoplay();
    });

    // Desktop hover behavior
    hero.addEventListener("mousemove", function (e) {
      if (isMobile()) return; // Skip on mobile

      const heroRect = hero.getBoundingClientRect();
      const mouseX = e.clientX - heroRect.left;
      const heroWidth = heroRect.width;
      const halfWidth = heroWidth / 2;

      let targetColumn = null;

      // Determine which half of the hero the mouse is in
      if (videoColumns.length === 2) {
        if (mouseX < halfWidth) {
          targetColumn = videoColumns[0];
        } else {
          targetColumn = videoColumns[1];
        }
      } else if (videoColumns.length === 1) {
        targetColumn = videoColumns[0];
      }

      // Play the video in the target column, pause others
      if (targetColumn && targetColumn !== currentlyPlayingVideo) {
        videoColumns.forEach(function (column) {
          const video = column.querySelector('video');
          if (video) {
            if (column === targetColumn) {
              video.play();
            } else {
              video.pause();
            }
          }
        });
        currentlyPlayingVideo = targetColumn;
      }
    });

    hero.addEventListener("mouseleave", function () {
      if (isMobile()) return; // Skip on mobile

      // Pause all videos when mouse leaves the hero
      videoColumns.forEach(function (column) {
        const video = column.querySelector('video');
        if (video) {
          video.pause();
        }
      });
      currentlyPlayingVideo = null;
    });
  });
});
